import { map, pick } from 'lodash'

const transformToUpdateDishTypeAlternativeIngredientsDetailsArgs = data =>
  map(data.alternativeIngredients, alternativeIngredientPair =>
    pick(alternativeIngredientPair, [
      'ingredientId',
      'alternativeIngredientId',
      'notes',
    ]),
  )

export default transformToUpdateDishTypeAlternativeIngredientsDetailsArgs
